import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=a32fc50c&scoped=true&"
import script from "./manifest.vue?vue&type=script&lang=js&"
export * from "./manifest.vue?vue&type=script&lang=js&"
import style0 from "./manifest.vue?vue&type=style&index=0&id=a32fc50c&lang=less&scoped=true&"
import style1 from "./manifest.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32fc50c",
  null
  
)

export default component.exports